import React, {useEffect, useState} from 'react';
import {useLocation, useParams} from "react-router-dom";
import {useNavigate} from "react-router";
import axios from "../../../helpers/axios";
import TouristServicesForm from "../components/TouristServicesForm";
import Loader from "../../../components/loader";
import BlockUi from "@availity/block-ui";
import {RailListRoute, TouristServicesListRoute} from "../../routesConstants";
import moment from "moment/moment";
import _ from 'lodash'
import sayError from "../../../helpers/sayError";
import {Helmet} from "react-helmet";

const TouristServicesEdit = () => {
  const {id} = useParams();
  const [loading, setLoading] = useState(false)
  const navigate=useNavigate()
  const [data, setData] = useState()

  const getService = () =>{
    setLoading(true)
    axios.get('/api/touristServices/'+id)
      .then(({data})=>{
        console.log('item', data)
        setData({...data.order, edit:true})
        setLoading(false)
      })
  }
  useEffect(() => {
    getService()
  }, [id]);
  const onSubmit = (data) =>{
    console.log('edit')
    setLoading(true)
    data.serviceItems.forEach((item)=>{
      item.startDate = moment(item.startDate, 'DD.MM.YYYY').format('DD.MM.YYYY HH:mm')
      item.endDate = moment(item.endDate, 'DD.MM.YYYY').format('DD.MM.YYYY HH:mm')
    })
    data.issueDate = moment(data.issueDate, 'DD.MM.YYYY').format('DD.MM.YYYY HH:mm')

    axios.patch('/api/touristServices/'+id, data)
      .then(({data})=>{
        navigate(TouristServicesListRoute)
        console.log('uploadstatus',data)
        if(typeof data.uploadResult === 'object'){
          window.alert("Загрузка прошла успешно!Но при выгрузке в 1с произошла ошибка. Обратитесь к тех.специалисту")
        }
      })
      .finally(()=>setLoading(false))
  }
  if(!data){
    return <Loader/>
  }
  const removeOrder = () =>{
    setLoading(true)
    if(window.confirm(`Вы уверены что хотите ${data?.isDeleted ?'восстановить':'удалить'} Инвойс?`)){
      axios.delete('/api/touristServices/'+id,{data:data?.isDeleted ? {"restore": true}:{}})
        .then(()=>{
          if(data?.isDeleted){
            getService()
          }else{
            navigate(TouristServicesListRoute)
          }
        })
        .finally(()=>setLoading(false))
    }
  }
  return (
    <>
      <Helmet>
        <title>Услуга</title>
      </Helmet>
      <BlockUi blocking={loading}>
        <TouristServicesForm data={data}
                             onSubmit={onSubmit}
                             reload={getService}
                             edit
                             removeOrder={removeOrder}/>
      </BlockUi>
    </>
  );
};

export default TouristServicesEdit;
